import React from 'react';
import { Box } from '@mui/material';

/**
 * A fixed pin overlaid dead-center on a map container. Every map in this app keeps its
 * `center` prop locked to the selected/displayed coordinates (see LocationMapInlineEditor,
 * LocationMapPickerDialog, LocationMapView), so a pin permanently glued to the visual
 * center of the container - via plain CSS, not a Google Maps overlay - always points at
 * the right spot without needing to track a lat/lng-to-pixel projection ourselves.
 *
 * This intentionally does not use `google.maps.Marker`: in some environments its default
 * glyph asset silently never loads (no network request, no console error - it just never
 * renders), so a plain HTML/CSS pin is the reliable choice here.
 */
export const MapCenterPin: React.FC = () => (
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -100%)',
      pointerEvents: 'none',
      filter: 'drop-shadow(0 2px 2px rgba(0,0,0,0.35))',
      zIndex: 1,
    }}
  >
    <svg width="32" height="40" viewBox="0 0 32 40" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 0C7.163 0 0 7.163 0 16c0 11.5 16 24 16 24s16-12.5 16-24C32 7.163 24.837 0 16 0z"
        fill="#1976d2"
        stroke="#ffffff"
        strokeWidth={2}
      />
      <circle cx={16} cy={16} r={6} fill="#ffffff" />
    </svg>
  </Box>
);
